import React from 'react';

import SquareBadges from './SquareBadges';
import CircleBadges from './CircleBadges';
import classNames from 'classnames';

type Props = {
  onClick: () => void;
  data: {
    id?: string;
    firstName: string;
    lastName: string;
    photoUrl?: string;
  }[];
  squareBadges?: boolean;
  additionalGuests: number;
  title: string;
  secondaryDefaultText: React.ReactNode;
  badgeType?: BadgeType;
};

export enum BadgeType {
  Regular = 'regular',
  Large = 'large'
}

// TODO: Make this composable to reduce the number of props
const EventUsersBadge = ({
  onClick,
  data,
  squareBadges,
  additionalGuests,
  title,
  secondaryDefaultText,
  badgeType = BadgeType.Regular
}: Props) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div
      className={classNames(
        'p-4 flex items-center justify-between border-1 rounded-md cursor-pointer',
        badgeType === BadgeType.Large && 'min-w-[250px] gap-4'
      )}
      onClick={handleClick}
    >
      <div className="flex flex-col justify-center">
        <div
          className={classNames(
            'text-neutral-500',
            badgeType === BadgeType.Large
              ? 'text-sm font-bold'
              : 'text-base font-semibold'
          )}
        >
          {title}
        </div>
        <div
          className={classNames(
            'font-normal',
            badgeType === BadgeType.Large ? 'text-lg text-gray-600' : 'text-sm'
          )}
        >
          {secondaryDefaultText}
        </div>
      </div>
      <div
        className={classNames(
          badgeType === BadgeType.Large && 'overflow-hidden'
        )}
      >
        {squareBadges ? (
          <SquareBadges data={data} additionalUsers={additionalGuests} />
        ) : (
          <CircleBadges data={data} additionalUsers={additionalGuests} fluid />
        )}
      </div>
    </div>
  );
};

export default EventUsersBadge;
